import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import AuthModal from '../AuthModal/AuthModal';

function LoginPage() {
    const [showAuthModal, setShowAuthModal] = useState(true);
    const [authMode, setAuthMode] = useState('login');
    const navigate = useNavigate();

    const handleCloseModal = () => {
        // Navigate back to home when modal is closed
        navigate('/');
    };

    const handleSwitchMode = (mode) => {
        setAuthMode(mode);
    };

    return (
        <div className="login-page-container">
            {showAuthModal && (
                <AuthModal 
                    mode={authMode} 
                    onClose={handleCloseModal} 
                    onSwitchMode={handleSwitchMode}
                />
            )}
        </div>
    );
}

export default LoginPage;
